import { Directive, ElementRef, Input, AfterViewInit, Renderer2, AfterViewChecked } from '@angular/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { AvailableBSPositions } from "ngx-bootstrap/positioning";

@Directive({
    selector: '[tooltip]:not([toggleTooltip])',
    standalone: false
})
export class TooltipEllipsifyDirective implements AfterViewInit, AfterViewChecked {
  @Input() maxlength = '';
  @Input() placement = 'auto';
  constructor(private el: ElementRef, private renderer: Renderer2, private tooltip: TooltipDirective) {}

  ngAfterViewChecked(): void {
    const element = this.el.nativeElement;
    if (element.offsetWidth < element.scrollWidth) {
      this.tooltip.isDisabled = false;
    } else {
      this.tooltip.isDisabled = true;
    }
  }

  ngAfterViewInit(): void {
    this.tooltip.isDisabled = false;
    this.tooltip.placement=this.placement as AvailableBSPositions;
    if (!this.maxlength) return;
    const elipsifyme = {
      'text-overflow': 'ellipsis',
      'overflow': 'hidden',
      'white-space': 'nowrap',
      'max-width': this.maxlength
    };
    Object.keys(elipsifyme).forEach(element=> {
      this.renderer.setStyle(
        this.el.nativeElement, `${element}`, elipsifyme[element]
      );
    });
  }

}


